import { render, staticRenderFns } from "./production-report.vue?vue&type=template&id=557a4116&scoped=true&"
import script from "./production-report.vue?vue&type=script&lang=js&"
export * from "./production-report.vue?vue&type=script&lang=js&"
import style0 from "./production-report.vue?vue&type=style&index=0&id=557a4116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557a4116",
  null
  
)

export default component.exports